import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/recruiting-job-categories/profile/loading';

export const Route = createFileRoute('/_private/settings/recruiting-job-categories/$id')({
  pendingComponent: Loading,
});
